// extracted by mini-css-extract-plugin
module.exports = {"HTMLContent":"styles-module--HTMLContent--3jSjU","WhiteText":"styles-module--WhiteText--1Duh0"};